module.exports = __webpack_public_path__ + "img/sponser-7.1c5fd350.png";